import styled from "styled-components";
import { color, units } from "@m/alchemy-theme";
export const AppNavOverflowButtonWrapper = styled.span `
  display: block;
  margin-left: -${units(1)};
`;
export const AppNavOverflowButtonLabel = styled.span `
  color: ${color("typeHeader")};
  opacity: 0.3;
`;
